<!-- Prev/Next navigation for the Wizard component

Props:

* {Boolean} disabled - When set, nav buttons will be disabled
* {Boolean} first - If set, the "prev" button won't be shown
* {Boolean} last - If set, the "next" button won't be shown

Slots:

* prev - HTML to show instead of the "prev" button
* next - HTML to show instead of the "next" button

-->
<template>
  <b-row class="mt-2">
    <b-col v-if="!first">
      <slot name="prev">
        <b-button
          :disabled="disabled"
          @click="$_goto('prev')"
        >
          &larr; Previous
        </b-button>
      </slot>
    </b-col>
    <b-col
      v-if="!last"
      class="text-right"
    >
      <slot name="next">
        <b-button
          variant="primary"
          :disabled="disabled"
          @click="$_goto('next')"
        >
          Next &rarr;
        </b-button>
      </slot>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'WizardPrevNext',
  props: {
    disabled: Boolean,
    first: Boolean,
    last: Boolean,
  },
  methods: {
    $_goto(where) {
      this.$eventHub.$emit('navigate-attempt', where);
    },
  },
};
</script>
